import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadDepartmentsQueryVariables = {
  search?: Types.Maybe<Types.Scalars['String']>
};


export type ReadDepartmentsQuery = (
  { __typename?: 'Query' }
  & { departments: Array<(
    { __typename?: 'Department' }
    & Pick<Types.Department, '_id' | '_deleted' | 'department'>
    & { headOfDepartment: (
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles' | 'external' | 'companyName' | 'userType'>
    ) }
  )> }
);

export type CreateDepartmentMutationVariables = {
  input: Types.DepartmentInsertInput
};


export type CreateDepartmentMutation = (
  { __typename?: 'Mutation' }
  & { createDepartment: (
    { __typename?: 'Department' }
    & Pick<Types.Department, '_id'>
  ) }
);

export type UpdateDepartmentMutationVariables = {
  id: Types.Scalars['ID'],
  update: Types.DepartmentUpdateInput
};


export type UpdateDepartmentMutation = (
  { __typename?: 'Mutation' }
  & { updateDepartment: (
    { __typename?: 'Department' }
    & Pick<Types.Department, '_id'>
  ) }
);

export type DeleteDepartmentMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteDepartmentMutation = (
  { __typename?: 'Mutation' }
  & { deleteDepartment: Array<(
    { __typename?: 'Department' }
    & Pick<Types.Department, '_id'>
  )> }
);

export const ReadDepartmentsDocument = gql`
    query ReadDepartments($search: String) {
  departments(filter: {department: {REGEX: $search, OPTIONS: "i"}}, sort: {department: ASC}) {
    _id
    _deleted
    department
    headOfDepartment {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
      external
      companyName
      userType
    }
  }
}
    `;

    export function useReadDepartmentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadDepartmentsQuery, ReadDepartmentsQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadDepartmentsQuery, ReadDepartmentsQueryVariables>(ReadDepartmentsDocument, baseOptions);
    };
      export function useReadDepartmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadDepartmentsQuery, ReadDepartmentsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadDepartmentsQuery, ReadDepartmentsQueryVariables>(ReadDepartmentsDocument, baseOptions);
      };
      
export type ReadDepartmentsQueryHookResult = ReturnType<typeof useReadDepartmentsQuery>;
export type ReadDepartmentsQueryResult = ApolloReactCommon.QueryResult<ReadDepartmentsQuery, ReadDepartmentsQueryVariables>;
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($input: DepartmentInsertInput!) {
  createDepartment(input: $input) {
    _id
  }
}
    `;
export type CreateDepartmentMutationFn = ApolloReactCommon.MutationFunction<CreateDepartmentMutation, CreateDepartmentMutationVariables>;

    export function useCreateDepartmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, baseOptions);
    };
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>;
export type CreateDepartmentMutationResult = ApolloReactCommon.MutationResult<CreateDepartmentMutation>;
export type CreateDepartmentMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($id: ID!, $update: DepartmentUpdateInput!) {
  updateDepartment(id: $id, update: $update) {
    _id
  }
}
    `;
export type UpdateDepartmentMutationFn = ApolloReactCommon.MutationFunction<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;

    export function useUpdateDepartmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, baseOptions);
    };
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = ApolloReactCommon.MutationResult<UpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const DeleteDepartmentDocument = gql`
    mutation DeleteDepartment($ids: [ID!]!) {
  deleteDepartment(ids: $ids) {
    _id
  }
}
    `;
export type DeleteDepartmentMutationFn = ApolloReactCommon.MutationFunction<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;

    export function useDeleteDepartmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>(DeleteDepartmentDocument, baseOptions);
    };
export type DeleteDepartmentMutationHookResult = ReturnType<typeof useDeleteDepartmentMutation>;
export type DeleteDepartmentMutationResult = ApolloReactCommon.MutationResult<DeleteDepartmentMutation>;
export type DeleteDepartmentMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteDepartmentMutation, DeleteDepartmentMutationVariables>;